import { Component, input } from '@angular/core';
import {
  RdsDividerModule,
  RdsIconsModule,
  RdsLinkModule,
} from '@rds/angular-components';

@Component({
  selector: 'inexp-knowledge-additional-resources',
  imports: [RdsLinkModule, RdsIconsModule, RdsDividerModule],
  templateUrl: './knowledge-additional-resources.component.html',
  styleUrl: './knowledge-additional-resources.component.scss',
})
export class KnowledgeAdditionalResourcesComponent {
  _uid = input<string>();
  component = input<string>();
  knowledgeSection = input<string>();
  additionalResources = input<any[]>();
  hasPublishedItems(): boolean {
    return this.additionalResources()?.some(b => b.published === true) ?? false;
  }
}
